import {Injectable} from "@angular/core";

@Injectable()
export class RutasWebServices{
	//public url:string="http://localhost/json_sys"
	//public url:string="http://localhost:8016"
	//public url:string='http://localhost:60031/api';
	//public url:string="http://130.103.97.40:8083/api";
	public url:string=localStorage.getItem('App_UrlServicioApiBack');


	
	urlWebService(tipo:string){

		switch (tipo) {
			
			case "GetDetalleOrdenesHCByNumOrden":
				return this.url+"/HistoriaClinica/GetDetalleOrdenesHCByNumOrden";

			case "GetDetalleOrdenesExternas":
				return this.url+"/HistoriaClinica/GetDetalleOrdenesExternas";

			case "SaveOrdenExtraHospitalariaMcto":
				return this.url+"/HistoriaClinica/SaveOrdenExtraHospitalariaMcto";

			case "GetBuscadorMedicamentos":
				return this.url+"/HistoriaClinica/GetBuscadorMedicamentos";

			case "GetListadoOE":
				return this.url+"/HistoriaClinica/GetListadoOE";

			case "SaveOrdenExtraHospitalariaPcto":
				return this.url+"/HistoriaClinica/SaveOrdenExtraHospitalariaPcto";

			case "GetMedicosActivos":
				return this.url+"/SisMedi/GetMedicosActivos";
			
			case "GetOrdenesProcedimientosOrdenIntrahospitalaria":
				return this.url+"/HistoriaClinica/GetOrdenesProcedimientosOrdenIntrahospitalaria";

			case "SaveOrdenIntrahospitalariaPcto":
				return this.url+"/HistoriaClinica/SaveOrdenIntrahospitalariaPcto";

			case "OrdenIntrahospitalariaGetServicios":
				return this.url+"/HistoriaClinica/OrdenIntrahospitalariaGetServicios";

			case "OrdenIntrahospitalariaGetProcedimientos":
				return this.url+"/HistoriaClinica/OrdenIntrahospitalariaGetProcedimientos";

			case "GetDetalleOrdenMcto":
				return this.url+"/HistoriaClinica/GetDetalleOrdenMcto";

			case "GetOrdenesMctoByEstudio":
				return this.url+"/HistoriaClinica/GetOrdenesMctoByEstudio";

			case "SaveOrdenIntrahospitalariaMcto":
				return this.url+"/HistoriaClinica/SaveOrdenIntrahospitalariaMcto";

			case "GetViasAdministracion":
				return this.url+"/HistoriaClinica/GetViasAdministracion";

			case "GetUND_Mcto":
				return this.url+"/HistoriaClinica/GetUND_Mcto";

			case "OrdenIntrahospitalariaGetMedicamento":
				return this.url+"/HistoriaClinica/OrdenIntrahospitalariaGetMedicamento";

			case "SaveHistoriaClinica":
				return this.url+"/HistoriaClinica/SaveHistoriaClinica";

			case "GetProcedimientosConsultasHC":
				return this.url+"/HistoriaClinica/GetProcedimientosConsultasHC";

			case "GetDestinoPaciente":
				return this.url+"/DestinoPaciente";

			case "GetFinalidades":
				return this.url+"/Sismaelm/GetFinalidades";

			case "GetTipoDiagnosticos":
				return this.url+"/Sismaelm/GetTipoDiagnosticos";
			
			case "GetCausaExterna":
				return this.url+"/Sismaelm/GetCausaExterna";
			
			case "GetServiciosHC":
				return this.url+"/HistoriaClinica/GetServiciosHC";
			
			case "GetDiagnosticosByEstudio":
				return this.url+"/NuevaEvolucion/GetDiagnosticos";
			
			case "GetProcedimientosEvolucion":
				return this.url+"/NuevaEvolucion/GetProcedimientosEvolucion";

			case "ParaclinicosGetFormatoResultado":
				return this.url+"/Paraclinicos/GetFormatoResultado";
	
			case "SaveFormatoEvolucion":
				return this.url+"/NuevaEvolucion/SaveFormatoEvolucion";

			case "SavePlantillaEstatica":
				return this.url+"/ZeusAppParaclinicos/SavePlantillaEstatica";
			
			case "SavePlantillaDinamica":
				return this.url+"/ZeusAppParaclinicos/SavePlantillaDinamica";
			
			case "GetFormatoEvolucion":
				return this.url+"/NuevaEvolucion/GetFormatoEvolucion";

			case "ParaclinicosEliminarExamen":
				return this.url+"/Paraclinicos/EliminarParaclinico";
			
			case "InactivarParaclinico":
				return this.url+"/Paraclinicos/InactivarParaclinico";
				

			case "ParaclinicoActivarExamen":
				return this.url+"/Paraclinicos/ActivarParaclinicoEliminado";

			case "ParaclinicosGetServicios":
				return this.url+"/Paraclinicos/GetServicios";

			case "ParaclinicosGetExamenes":
				return this.url+"/Paraclinicos/GetParaclinicosServicio";

			case "CancelarCita":
				return this.url+"/ZeusAppCitas/CancelarCita";
				
			case "ApartarCita":
				return this.url+"/ZeusAppCitas/ApartarCita";

			case "GetProgramacionDisponible":
				return this.url+"/ZeusAppCitas/GetProgramacionDisponible";

			case "GetCitasPaciente":
				return this.url+"/ZeusAppCitas/GetCitasPaciente";

			case "GetMedicos":
				return this.url+"/ZeusAppMedicos/GetMedicos";

			case "loginPaciente":
				return this.url+"/ZeusAppLogin/ValidUser";

			case "AccessTokenValid":
				return this.url+"/ZeusAppLogin/AccessTokenValid";

			case "GetAsuntos":
				return this.url+"/ZeusAppServicios/GetServicios";

			case "loginAsistencial":
				return this.url+"/ZeusAppLogin/ValidUserAsistencial";

			case "puntoAtencionByUser":
				return this.url+"/Usuariopuntoatencion/GetPuntosAtencionVinculadosUsuario";
			
			case "GetPabellones":
				return this.url+"/ZeusAppCenso/GetPabellones";

			case "GetDetallePabellon":
				return this.url+"/ZeusAppCenso/GetDetallePabellon";				

			case "GetEvolucionesPcte":
				return this.url+"/ZeusAppCenso/GetEvolucionesPcte";	
			
			case "GetDetalleEvolucion":
				return this.url+"/ZeusAppCenso/GetDetalleEvolucion";	

			case "GetNotasEnfermeria":
				return this.url+"/ZeusAppCenso/GetNotasEnfermeria";
				
			case "GetAgendaMedico":
				return this.url+"/ZeusAppCitas/GetAgendaMedico";	

			case "GetDatosHistoriaClinica":
				return this.url+"/ZeusAppCenso/GetDatosHistoriaClinica";

			case "GuardarNotaEnfermeria":
				return this.url+"/NotasEnfermeria/Save";
			
			case "GetMessagesChat":
				return this.url+"/AppChat/GetMessagesChatAndOper";

			case "GetFormatoGenerico":
				return this.url+"/FgFormatogenerico/GetFormatoGenerico";

			case "GuardarFirma":
				return this.url+"/FgFormatogenerico/GuardarFirma";

			case "FormatoGenericos":
				return this.url+"/FgFormatogenerico";
			
			case "GetDocumentosFirmados":
				return this.url+"/FgFormatogenerico/GetDocumentosFirmados";

			case "GetDataUserLogin":
					return this.url+"/Usuario/GetDataUserLogin";

			case "UpdateDataUserLogin":
				return this.url+"/Usuario/UpdateDataUserLogin";

			case "GetImageLogo":
				return this.url+"/ZeusAppConexiones/GetLogo64";

			case "GuardarDatosInicialesConferencia":
				return this.url+"/Zoom/SaveDataHcVideoConferencias";	
			default:
				return "";
		}	
	}

}